import React, { createContext, useContext, useMemo, type ReactNode } from 'react'
import { useInfoSheet } from '@fs/zion-ui'

type GedcomInfoSheetContextValue = {
  gedcomErrorsInfoSheet: ReturnType<typeof useInfoSheet>
  gedcomInfoSheet: ReturnType<typeof useInfoSheet>
}

const GedcomInfoSheetContext = createContext<GedcomInfoSheetContextValue | undefined>(undefined)

type Props = {
  children: ReactNode
}

export function GedcomInfoSheetProvider({ children }: Props): JSX.Element {
  const gedcomErrorsInfoSheet = useInfoSheet()
  const gedcomInfoSheet = useInfoSheet()
  const value = useMemo(() => ({ gedcomErrorsInfoSheet, gedcomInfoSheet }), [gedcomErrorsInfoSheet, gedcomInfoSheet])

  return <GedcomInfoSheetContext.Provider value={value}>{children}</GedcomInfoSheetContext.Provider>
}

export function useGedcomInfoSheets(): GedcomInfoSheetContextValue {
  const context = useContext(GedcomInfoSheetContext)

  if (!context) {
    throw new Error('useGedcomInfoSheets must be used within a GedcomInfoSheetProvider')
  }

  return context
}
